import request from '@/api/request'

export interface ArticleSummaryRow {
  id: number
  cid: number | null
  title: string
  addtime: number | null
  sort: number | null
  thumbnail: string | null
  description: string | null
  keywords: string | null
}

export interface ArticleDetail extends ArticleSummaryRow {
  cont: string | null
}

export function fetchArticles() {
  return request.get<ArticleSummaryRow[]>('/api/admin/articles')
}

export function fetchArticle(id: number) {
  return request.get<ArticleDetail>(`/api/admin/articles/${id}`)
}

export function createArticle(body: Record<string, unknown>) {
  return request.post<ArticleDetail>('/api/admin/articles', body)
}

export function patchArticle(id: number, body: Record<string, unknown>) {
  return request.patch<ArticleDetail>(`/api/admin/articles/${id}`, body)
}

export function deleteArticle(id: number) {
  return request.delete<{ status: number; msg: string }>(`/api/admin/articles/${id}`)
}
